<template>
  <div>
    <template
      v-for="(curso, index) in dadosCurso"
    >
      <CardFotoProduto
        :key="`foto-${curso.id}`"
        :imagem="curso.image_url"
        :possui-card-superior="possuiCardSuperior || index > 0"
        :titulo="curso.name"
        :produtos="[curso]"
      />
      <v-card
        :key="curso.id"
        class="mb-5 pa-5"
      >
        <p
          v-if="$vuetify.breakpoint.smAndDown"
          class="primary--text mb-3"
          data-cy="entrega_nome_produto"
        >
          {{ curso.name }}
        </p>

        <p
          class="mb-3 grey--text text--darken-2"
          data-cy="label_texto_curso"
        >
          Acesse seu conteúdo de qualquer lugar e bons estudos!
        </p>

        <v-card-actions
          class="flex-column pa-0"
        >
          <v-btn
            color="primary"
            data-cy="curso_url"
            block
            target="_blank"
            :href="curso.course_link"
            @click="scoreConsumidor(dadosTransacao.id)"
          >
            Acessar meu conteúdo
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import CardFotoProduto from '@/components/Compras/CardFotoProduto.vue';
import api from '@/api';
import { mapState } from 'vuex';

export default {
  name: 'CardAcessarCurso',

  components: {
    CardFotoProduto,
  },

  props: {
    dadosCurso: {
      type: Array,
      required: true,
    },
    possuiCardSuperior: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['dadosTransacao']),
  },

  methods: {
    async scoreConsumidor(orderId) {
      await api.post('/consumer_score', {
        action: 'membertizze_digital_products',
        orderId,
      });
    },
  },
};
</script>
